<template>
  <h1>汇总</h1>
</template>

<script>
export default {
  name: 'OrganizationSumary'
}
</script>

<style scoped>

</style>
